import iconIguana from '../assets/images/attractions/icon/iguana.webp';
import iconMorricana from '../assets/images/attractions/icon/morricana.webp';
import iconPizzo from '../assets/images/attractions/icon/pizzo.webp';
import iconLepri from '../assets/images/attractions/icon/lepri.webp';


import imgIguana from '../assets/images/attractions/img/iguana.webp';
import imgMorricana from '../assets/images/attractions/img/morricana.webp';
import imgPizzo from '../assets/images/attractions/img/pizzo.webp';
import imgLepri from '../assets/images/attractions/img/lepri.webp';



import {locals} from './map'

const attractions = [
    {
        title: "Iguana",
        id: "attraction-iguana",
        img : imgIguana,
        icon : iconIguana,
        text: "Iguana rocciosa formatasi naturalmente che domina il lato sud-est del Monte Pelone.",
        coords:locals.iguana,
        tags: ['1836m', 'Prato', 'Formazione Naturale']
    },
    {
        title: "Cascata della Morricana",
        id: "attraction-morricana",
        img: imgMorricana,
        icon : iconMorricana,
        text: "testo cascata morricana",
        coords: locals.morricana,
        tags: ['Cascata', 'Bosco', 'Formazione Naturale']
    },
    {
        title: "Pizzo di Moscio",
        id: "attraction-pizzo",
        img: imgPizzo,
        icon : iconPizzo,
        text: "testo pizzo di moscio",
        coords: locals.pizzo,
        tags: ['Montagna', 'Appennini', '2411m']
    },
    {
        title: "Cima Lepri",
        id: "attraction-lepri",
        img: imgLepri,
        icon : iconLepri,
        text: "testo cima lepri",
        coords: locals.lepri,
        tags: ['Montagna', 'Appennini', '2449m']
    },
]

export {attractions};